import { render } from "./BusinessEthics.vue?vue&type=template&id=f093d338&scoped=true"
import script from "./BusinessEthics.vue?vue&type=script&lang=js"
export * from "./BusinessEthics.vue?vue&type=script&lang=js"

import "./BusinessEthics.vue?vue&type=style&index=0&id=f093d338&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f093d338"]])

export default __exports__